"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:6.2.4'] && _();
}
catch (e) { }
